import { createApp } from 'vue'
import App from './App.vue'
import './index.scss'
import VueSmoothScroll from 'vue3-smooth-scroll'


const app = createApp(App).use(VueSmoothScroll)
app.mount('#app')